import React from "react";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Conversation from "./conversation";
import Header from "./header";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";

const Conversations = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const { orderedMatchIDs, clientID } = getKhattabat101MGeneralStore();
  const matchIds = orderedMatchIDs.get();
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="space-between"
      alignItems="center"
      withShadow={true}
      width={1450}
      height={0}
      color={colors.all.white}
      style={{
        borderRadius: 30 * unitX,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      {matchIds.map((matchID) => {
        return (
          <React.Fragment key={matchID}>
            <Header matchID={matchID} />
            <Conversation matchID={matchID} clientID={clientID.get()} />
          </React.Fragment>
        );
      })}
    </ET3Div>
  );
});

export default Conversations;
